import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {SocketIoModule} from 'ngx-socket-io';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
    SocketIoModule,
  ],
})
export class TorchFilesModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchFilesModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchFilesModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchFilesModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchFilesModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
